"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _anchor = require("@/api/anchor");
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      listLoading: false,
      audit: {},
      auditList: [],
      auditTotal: 0,
      listQuery: {
        page: 1,
        size: 10,
        type: 1,
        user_id: '',
        price: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$anchorBrokerLi, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _anchor.anchorBrokerList)(this.listQuery);
            case 1:
              _yield$anchorBrokerLi = _context.v;
              code = _yield$anchorBrokerLi.code;
              data = _yield$anchorBrokerLi.data;
              this.listLoading = false;
              if (code === 0) {
                this.auditList = data.list;
                this.auditTotal = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleFilter: function () {
      var _handleFilter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listQuery.page = 1;
              this.getList();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleFilter() {
        return _handleFilter.apply(this, arguments);
      }
      return handleFilter;
    }()
  }
};